import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { RegisterForm } from '../RegisterForm';
import { AuthBackLink } from '../layout/AuthBackLink';
import { AuthBrandHeader } from '../layout/AuthBrandHeader';

/**
 * Left panel with registration form.
 */
export function RegisterLeftPanel() {
  return (
    <div className="w-full lg:w-1/2 flex flex-col bg-white">
      <header className="p-6">
        <AuthBackLink />
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-sm"
        >
          <AuthBrandHeader
            heading="Create your account"
            subheading="Get started with VR Meet for free"
          />

          <RegisterForm />

          <p className="text-center text-gray-500 mt-8">
            Already have an account?{' '}
            <Link
              to="/login"
              className="font-medium text-brand-teal hover:text-brand-blue transition-colors"
            >
              Sign in
            </Link>
          </p>
        </motion.div>
      </main>
    </div>
  );
}
